module.exports = __webpack_public_path__ + "static/logo-c3088fe63ceab5a47dbc2806432db930.png";